import { API_BASE_URL as API_BASE } from './config';

export const breakingHeadlineAPI = {
  // Get active breaking headlines (public)
  getBreakingHeadlines: async () => {
    try {
      const response = await fetch(`${API_BASE}/breaking-headlines`);
      const data = await response.json();
      if (data.success) {
        return data.data;
      }
      throw new Error(data.message || 'Failed to fetch breaking headlines');
    } catch (error) {
      console.error('Error fetching breaking headlines:', error);
      return [];
    }
  },

  // Get all headlines for admin (including inactive)
  getAllHeadlines: async (page = 1, limit = 10) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `${API_BASE}/breaking-headlines/admin/all?page=${page}&limit=${limit}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      const data = await response.json();
      if (data.success) {
        return data;
      }
      throw new Error(data.message || 'Failed to fetch headlines');
    } catch (error) {
      console.error('Error fetching all headlines:', error);
      throw error;
    }
  },

  // Add new breaking headline
  addHeadline: async (headline) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE}/breaking-headlines/admin/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ headline })
      });
      const data = await response.json();
      if (data.success) {
        return data;
      }
      throw new Error(data.message || 'Failed to add headline');
    } catch (error) {
      console.error('Error adding headline:', error);
      throw error;
    }
  },

  // Update breaking headline
  updateHeadline: async (id, headline, isActive) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE}/breaking-headlines/admin/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ headline, isActive })
      });
      const data = await response.json();
      if (data.success) {
        return data;
      }
      throw new Error(data.message || 'Failed to update headline');
    } catch (error) {
      console.error('Error updating headline:', error);
      throw error;
    }
  },

  // Delete breaking headline
  deleteHeadline: async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE}/breaking-headlines/admin/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        return data;
      }
      throw new Error(data.message || 'Failed to delete headline');
    } catch (error) {
      console.error('Error deleting headline:', error);
      throw error;
    }
  },

  // Reorder breaking headlines
  reorderHeadlines: async (orderedIds) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE}/breaking-headlines/admin/reorder`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ orderedIds })
      });
      const data = await response.json();
      if (data.success) {
        return data;
      }
      throw new Error(data.message || 'Failed to reorder headlines');
    } catch (error) {
      console.error('Error reordering headlines:', error);
      throw error;
    }
  },

  // Toggle headline active status
  toggleHeadlineStatus: async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE}/breaking-headlines/admin/${id}/toggle`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        return data;
      }
      throw new Error(data.message || 'Failed to toggle headline status');
    } catch (error) {
      console.error('Error toggling headline status:', error);
      throw error;
    }
  }
};
